import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const isRoute = (p) => (pathname === p ? 'text-white bg-gradient-to-r from-purple-600 to-indigo-600' : 'text-gray-700 hover:text-purple-600 hover:bg-purple-50');

  // Main domain URL - hardcoded to ensure navigation from subdomains works
  const mainDomain = 'https://buildyourdevops.com';

  const scrollTo = (id) => {
    // Check if we're on a subdomain or non-home page
    const isSubdomain = window.location.hostname !== 'buildyourdevops.com' && !window.location.hostname.includes('localhost');

    if (pathname !== '/' || isSubdomain) {
      // Use absolute URL to main domain to ensure navigation from subdomains
      window.location.href = `${mainDomain}/#${id}`;
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed w-full z-50 bg-white/95 backdrop-blur-md shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <a href="https://buildyourdevops.com/" className="font-bold text-xl bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent">
            BuildYourDevOps
          </a>
          <div className="hidden lg:flex items-center space-x-1">
            <button onClick={() => scrollTo('home')} className={`px-4 py-2 rounded-lg font-medium text-sm ${isRoute('/#home')}`}>Home</button>
            <button onClick={() => scrollTo('about')} className={`px-4 py-2 rounded-lg font-medium text-sm ${isRoute('/#about')}`}>About</button>
            <button onClick={() => scrollTo('services')} className={`px-4 py-2 rounded-lg font-medium text-sm ${isRoute('/#services')}`}>Services</button>
            <button onClick={() => scrollTo('case-studies')} className={`px-4 py-2 rounded-lg font-medium text-sm ${isRoute('/#case-studies')}`}>Case Studies</button>
            <a href="https://buildyourdevops.com/blog" className={`px-4 py-2 rounded-lg font-medium text-sm ${isRoute('/blog')}`}>Blog</a>
            <button onClick={() => scrollTo('testimonials')} className={`px-4 py-2 rounded-lg font-medium text-sm ${isRoute('/#testimonials')}`}>Testimonials</button>
            <button onClick={() => scrollTo('contact')} className={`px-4 py-2 rounded-lg font-medium text-sm ${isRoute('/#contact')}`}>Contact</button>
            <Link to="/admin/login" className="px-4 py-2 rounded-lg font-semibold text-sm text-white bg-gradient-to-r from-purple-600 to-indigo-600">Admin</Link>
          </div>
          <button className="lg:hidden px-3 py-2 rounded-md border border-gray-200" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            Menu
          </button>
        </div>
      </div>
      {isMenuOpen && (
        <div className="lg:hidden bg-white shadow-2xl border-t">
          <button onClick={() => scrollTo('home')} className="block w-full text-left px-6 py-4 hover:bg-purple-50">Home</button>
          <button onClick={() => scrollTo('about')} className="block w-full text-left px-6 py-4 hover:bg-purple-50">About</button>
          <button onClick={() => scrollTo('services')} className="block w-full text-left px-6 py-4 hover:bg-purple-50">Services</button>
          <button onClick={() => scrollTo('case-studies')} className="block w-full text-left px-6 py-4 hover:bg-purple-50">Case Studies</button>
          <a href="https://buildyourdevops.com/blog" className="block w-full text-left px-6 py-4 hover:bg-purple-50">Blog</a>
          <button onClick={() => scrollTo('testimonials')} className="block w-full text-left px-6 py-4 hover:bg-purple-50">Testimonials</button>
          <button onClick={() => scrollTo('contact')} className="block w-full text-left px-6 py-4 hover:bg-purple-50">Contact</button>
          <Link to="/admin/login" className="block w-full text-left px-6 py-4 hover:bg-purple-50">Admin</Link>
        </div>
      )}
    </nav>
  );
}


